import apiRequest from "../../utils/apiRequest";

/**
 * Services HTTP des domaines Invoice et FinancialTransaction.
 *
 * <p>Contrat back :
 * <ul>
 *   <li>POST /invoice → 201 + Long (id).</li>
 *   <li>GET /invoice/{id} → InvoiceResponse.</li>
 *   <li>DELETE /invoice/{id} → 200/204 (void).</li>
 *   <li>GET /invoice/by-patient/{patientId} → List&lt;InvoiceResponse&gt;
 *       (non paginé — réponse tableau plat).</li>
 *   <li>POST /invoice/initiate-payment/{id} → Map FedaPay.</li>
 *   <li>PUT /invoice/mark-as-paid-cash/{id} → void.</li>
 *   <li>GET /invoice/invoice-pdf/{id} → PDF (binary).</li>
 *   <li>GET /financial-transaction → List&lt;FinancialTransactionResponse&gt;.</li>
 *   <li>PUT /financial-transaction/assign-to-invoice/{invoiceId} → void.</li>
 * </ul>
 */

/* ------------------------------------------------------------------ */
/* Invoice                                                             */
/* ------------------------------------------------------------------ */

export const createInvoice = async (payload) => {
  return apiRequest.post("/invoice", payload);
};

export const getInvoiceById = async (id) => {
  if (id == null) {
    return { ok: false, status: 0, message: "id manquant", error: "BadRequest" };
  }
  return apiRequest.get(`/invoice/${id}`);
};

export const deleteInvoice = async (id) => {
  if (id == null) {
    return { ok: false, status: 0, message: "id manquant", error: "BadRequest" };
  }
  return apiRequest.del(`/invoice/${id}`);
};

/**
 * Liste des factures d'un patient (tableau plat, non paginé).
 *
 * @param {number} patientId
 */
export const getInvoicesByPatient = async (patientId) => {
  if (patientId == null) {
    return { ok: false, status: 0, message: "patientId manquant", error: "BadRequest" };
  }
  return apiRequest.get(`/invoice/by-patient/${patientId}`);
};

export const initiatePayment = async (invoiceId) => {
  if (invoiceId == null) {
    return { ok: false, status: 0, message: "invoiceId manquant", error: "BadRequest" };
  }
  return apiRequest.post(`/invoice/initiate-payment/${invoiceId}`, undefined);
};

export const markInvoiceAsPaidCash = async (invoiceId) => {
  if (invoiceId == null) {
    return { ok: false, status: 0, message: "invoiceId manquant", error: "BadRequest" };
  }
  return apiRequest.put(`/invoice/mark-as-paid-cash/${invoiceId}`, undefined);
};

/* ------------------------------------------------------------------ */
/* FinancialTransaction                                                */
/* ------------------------------------------------------------------ */

export const getFinancialTransactions = async () => {
  return apiRequest.get("/financial-transaction");
};

export const assignTransactionToInvoice = async (invoiceId, transactionKey) => {
  if (invoiceId == null || !transactionKey) {
    return {
      ok: false,
      status: 0,
      message: "invoiceId ou transactionKey manquant",
      error: "BadRequest"
    };
  }
  return apiRequest.put(
    `/financial-transaction/assign-to-invoice/${invoiceId}`,
    { transactionKey }
  );
};
